import { baseApi } from './baseApi';
import { saveUser, logoutUser } from '../utils/auth';
import type { AuthResponse, LoginRequest, RegisterRequest } from '../types';

const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<AuthResponse, LoginRequest>({
      query: (body) => ({
        url: '/auth/login',
        method: 'POST',
        body,
      }),
      transformResponse: (response: AuthResponse) => {
        const { token, email, userId, displayName, userName } = response;
        saveUser({ token, email, userId, displayName, userName });
        return response;
      },
    }),

    register: builder.mutation<AuthResponse, RegisterRequest>({
      query: (body) => ({
        url: '/auth/signup',
        method: 'POST',
        body,
      }),
      transformResponse: (response: AuthResponse) => {
        const { token, email, userId, displayName, userName } = response;
        saveUser({ token, email, userId, displayName, userName });
        return response;
      },
    }),

    logout: builder.mutation<{ message: string }, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
      transformResponse: (response: { message: string }) => {
        logoutUser();
        return response;
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useLogoutMutation,
} = authApi;
